<template>
  <div>
    <b-card>
      <div slot="header">
        Calendar
      </div>
      <calendar v-model="data" mode="week"></calendar>
      <div>
        <pre>{{ data }}</pre>
      </div>
    </b-card>
  </div>
</template>

<script>
  import Calendar from '../components/Partials/Calendar'
  import DragDrop from '../components/Partials/DragDrop'
  import CustomAddMoreMenuItem from '../components/Partials/CustomAddMoreMenuItem'
  let vm = null
  
  export default {
    name: 'Component',
    components: {
      Calendar,
      DragDrop,
      CustomAddMoreMenuItem
    },
    data () {
      return {
        discount_unit_categories: [],
        categoryList: [],
        categories: {},
        items: [
          {
            uuid: 1,
            name: 'Item 1',
            sequence: 0
          },
          {
            uuid: 6,
            name: 'Item 6',
            sequence: 5
          },
          {
            uuid: 2,
            name: 'Item 2',
            sequence: 1
          },
          {
            uuid: 5,
            name: 'Item 5',
            sequence: 4
          },
          {
            uuid: 3,
            name: 'Item 3',
            sequence: 2
          },
          {
            uuid: 7,
            name: 'Item 7',
            sequence: 6
          },
          {
            uuid: 4,
            name: 'Item 4',
            sequence: 3
          }
        ],
        sort_field: 'sequence',
        data: {
          order_duration: [],
          special_date_open: [],
          special_date_close: [],
          huts_day: [],
          public_holiday: []
        }
      }
    },
    created: function () {
      vm = this
      vm.getMenuItems()
    },
    methods: {
      getMenuItems(){
        let params = '';
        vm.axios.coupon.getListCouponMenu(params, function(response) {
          let data = response.data.data.items
          let langs = vm.languages
          for (let l in langs) {
            let lang = langs[l]
            vm.categories[lang] = []
            for (let g in data) {
                let items = []
                let group = data[g]
                vm.categories[lang].push({
                    value: group['category_id'],
                    text: group['category_name'][lang]
                })
            }
          }
          vm.$forceUpdate('categories')
        })
      },
    },
    updated: function () {
      if (vm.categories[vm.$session.get('lang')]!==undefined) {
        vm.categoryList = vm.categories[vm.$session.get('lang')]
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Component.vue